import * as React from 'react';
import {StyleProp, StyleSheet, ViewStyle} from 'react-native';
import {useLinkTo} from '@react-navigation/native';

import BottomPrimaryButton from '../../../shared/buttons/BottomPrimaryButton';

interface Props {
  projectId: number;
  style?: StyleProp<ViewStyle>;
}

const EditProjectsButton: React.FC<Props> = props => {
  const {style, projectId} = props;
  const linkTo = useLinkTo();
  const onPress = React.useCallback(() => {
    linkTo(`/projects/${projectId}/edit`);
  }, []);
  return (
    <BottomPrimaryButton
      style={style}
      bottomButtonStyle={styles.bottomButton}
      onPress={onPress}>
      プロジェクトを編集する
    </BottomPrimaryButton>
  );
};

export default React.memo(EditProjectsButton);

const styles = StyleSheet.create({
  bottomButton: {
    position: 'absolute',
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  } as ViewStyle,
});
